import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function (state = initialState.certificateList, { type, payload }) {
    switch (type) {
        case types.PATIENT_CERTIFICATE_LIST_REQUEST:
            return {
                ...initialState.certificateList,
                isLoading: true,
                isStatus: 'request',
                request: payload,
                successResponse: {},
                errorResponse: {}
            };
        case types.PATIENT_CERTIFICATE_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isStatus: 'success',
                successResponse: payload,
                request: {}
            };
        case types.PATIENT_CERTIFICATE_LIST_FAILED:
            return {
                ...state,
                isLoading: false,
                isStatus: 'error',
                successResponse: {},
                errorResponse: payload,
                request: {}
            };
        default:
            return state;
    }
}